import type { ResultRecord } from '@dynatrace-sdk/client-query';

/**
 * Extracts a value from the record using the value's dimension name.
 * @param record - Record from a query
 * @param valueDimensionName - value dimension name
 */
export function extractValue<T>(
  record: ResultRecord,
  valueDimensionName?: string,
): T | undefined {
  if (valueDimensionName === undefined) {
    return undefined;
  }

  if (!record) {
    throw Error('Record has no values');
  }

  const value = record[valueDimensionName];

  // since there is no way of narrowing down the type here we need to cast it first
  return value as T | undefined;
}
